module.exports = __webpack_public_path__ + "static/ripple-d8491d4639599d646fa3ab8df7b9d980.png";